import { Reducer } from 'redux';
import { TransportOperatorsState, TransportOperatorsTypes } from './types';

const INITIAL_STATE: TransportOperatorsState = {
  transportOperatorData: {
    id: '',
    name: '',
    cnpj: '',
    createdAt: null,
    updatedAt: null,
    photoUrl: null,
    type: 0,
    SupervisorOperator: {
      id: '',
      modules: '',
      levels: '',
      supervisorId: '',
      operatorId: '',
    },
  },
  transportOperatorSelected: {
    id: '',
    name: '',
    cnpj: '',
    createdAt: null,
    updatedAt: null,
    photoUrl: null,
    type: 0,
    SupervisorOperator: {
      id: '',
      modules: '',
      levels: '',
      supervisorId: '',
      operatorId: '',
    },
  },
  transportOperatorsList: [],
  error: false,
  loading: false,
};

// LIST
const listTransportOperatorsRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
  transportOperatorsList: INITIAL_STATE.transportOperatorsList,
});

const listTransportOperatorsSuccess = (state: any, action: any) => ({
  ...state,
  loading: true,
  error: false,
  transportOperatorsList: action.payload.transportOperatorsList,
});

const listTransportOperatorsFailure = (state: any) => ({
  ...state,
  loading: true,
  error: false,
  transportOperatorsList: INITIAL_STATE.transportOperatorsList,
});

// SELECT
const selectTransportOperatorRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
  transportOperatorSelected: INITIAL_STATE.transportOperatorSelected,
});

const selectTransportOperatorSuccess = (state: any, action: any) => ({
  ...state,
  loading: true,
  error: false,
  transportOperatorSelected: action.payload.transportOperatorSelected,
});

const selectTransportOperatorFailure = (state: any = INITIAL_STATE) => ({
  ...state,
  loading: true,
  error: false,
  transportOperatorSelected: INITIAL_STATE.transportOperatorSelected,
});

// UPDATE
const updateTransportOperatorRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
});

const updateTransportOperatorSuccess = (state: any, action: any) => ({
  ...state,
  loading: true,
  error: false,
  transportOperatorsList: action.payload.transportOperatorsList,
  transportOperatorSelected: action.payload.transportOperatorSelected,
});

const updateTransportOperatorFailure = (state: any) => ({
  ...state,
  loading: true,
  error: false,
});

// REQUEST ACCESS TRANSPORT OPERATOR
const operatorAccessRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
});

const operatorAccessSuccess = (state: any, action: any) => ({
  ...state,
  loading: true,
  error: false,
});

const operatorAccessFailure = (state: any) => ({
  ...state,
  loading: true,
  error: false,
});

const reducer: Reducer<TransportOperatorsState> = (
  state = INITIAL_STATE,
  action,
) => {
  switch (action.type) {
    // CASES LIST TRANSPORT_OPERATORS
    case TransportOperatorsTypes.LIST_TRANSPORT_OPERATORS_REQUEST:
      return listTransportOperatorsRequest(state);
    case TransportOperatorsTypes.LIST_TRANSPORT_OPERATORS_SUCCESS:
      return listTransportOperatorsSuccess(state, action);
    case TransportOperatorsTypes.LIST_TRANSPORT_OPERATORS_FAILURE:
      return listTransportOperatorsFailure(state);

    // CASES SELECT TRANSPORT_OPERATORS
    case TransportOperatorsTypes.SELECT_TRANSPORT_OPERATOR_REQUEST:
      return selectTransportOperatorRequest(state);
    case TransportOperatorsTypes.SELECT_TRANSPORT_OPERATOR_SUCCESS:
      return selectTransportOperatorSuccess(state, action);
    case TransportOperatorsTypes.SELECT_TRANSPORT_OPERATOR_FAILURE:
      return selectTransportOperatorFailure(state);

    // CASES UPDATE TRANSPORT_OPERATORS
    case TransportOperatorsTypes.UPDATE_TRANSPORT_OPERATOR_REQUEST:
      return updateTransportOperatorRequest(state);
    case TransportOperatorsTypes.UPDATE_TRANSPORT_OPERATOR_SUCCESS:
      return updateTransportOperatorSuccess(state, action);
    case TransportOperatorsTypes.UPDATE_TRANSPORT_OPERATOR_FAILURE:
      return updateTransportOperatorFailure(state);

    // CASES REQUEST ACCESS TRANSPORT OPERATOR
    case TransportOperatorsTypes.OPERATOR_ACCESS_REQUEST:
      return operatorAccessRequest(state);
    case TransportOperatorsTypes.OPERATOR_ACCESS_SUCCESS:
      return operatorAccessSuccess(state, action);
    case TransportOperatorsTypes.OPERATOR_ACCESS_FAILURE:
      return operatorAccessFailure(state);

    default:
      return state;
  }
};

export default reducer;
